import { render, staticRenderFns } from "./AppCidadaoPrestadores.vue?vue&type=template&id=38923e88&"
import script from "./AppCidadaoPrestadores.vue?vue&type=script&lang=js&"
export * from "./AppCidadaoPrestadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports